import axios from 'axios';
import qsBuilder from 'utils/queryStringBuilder';

import {
  EVENTS_LOADING,
  EVENTS_LOADED,
  EVENTS_MORE,
  EVENTS_MAP,
  CONCERT_ATTENDING_UPDATED,
  CONCERT_DETAILS_LOADING,
  CONCERT_DETAILS_LOADED,
  GET_USER_CONCERTS,
} from 'actions/types';
import handleApiCall from './handleApiCall';
import reportError from 'utils/reportError';
import { Dispatch } from 'redux';

export interface Bounds {
  neLat: number;
  neLng: number;
  swLat: number;
  swLng: number;
}

interface EventProps {
  artistId?: number;
  userId?: number;
  lat?: number | null;
  lng?: number | null;
  start?: number;
  length?: number;
  bounds?: Bounds;
}

export const getEvents =
  ({ artistId, userId, lat, lng, start = 0, length }: EventProps) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: EVENTS_LOADING });
    const queryString = qsBuilder({ artistId, userId, lat, lng, start, length });
    const { data = [] } = (await axios.get(`/api/events/getEvents?${queryString}`)) || {};
    dispatch({ type: EVENTS_LOADED, data });
  };

export const getMoreEvents =
  ({ artistId, userId, lat, lng, start = 0, length }: EventProps) =>
  async (dispatch: Dispatch) => {
    const queryString = qsBuilder({ artistId, userId, lat, lng, start, length });
    const { data = [] } = (await axios.get(`/api/events/getEvents?${queryString}`)) || {};
    dispatch({ type: EVENTS_MORE, data });
  };

export const getMapEvents =
  ({ artistId, bounds, userId }: EventProps) =>
  async (dispatch: Dispatch) => {
    const queryString = qsBuilder({ artistId, bounds: JSON.stringify(bounds), userId });
    const { data = [] } = (await axios.get(`/api/events/getMapEvents?${queryString}`)) || {};
    dispatch({ type: EVENTS_MAP, data });
  };

export const getEventTickets = async (eventId: number) => {
  const { data = [] } = (await axios.get(`/api/events/tickets?eventId=${eventId}`)) || {};
  return data;
};

export const getEvent = (eventId: number) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: CONCERT_DETAILS_LOADING });
    const response = await axios.get(`/api/events/details?eventId=${eventId}`);
    if (response.status === 200) {
      dispatch({ type: CONCERT_DETAILS_LOADED, data: response.data });
    } else {
      dispatch({ type: CONCERT_DETAILS_LOADED, data: { error: true } });
    }
  } catch (e) {
    return null;
  }
};

export const setAttending =
  (eventId: number, type: string, value: string) => async (dispatch: Dispatch) => {
    try {
      const { data = [] } =
        (await handleApiCall('post', `/api/events/attending`, { eventId, type, value })) || {};
      dispatch({ type: CONCERT_ATTENDING_UPDATED, data, eventId });
      const { data: userConcerts } = await handleApiCall('get', '/api/events/userConcerts');
      if (userConcerts) {
        dispatch({ type: GET_USER_CONCERTS, data: userConcerts });
      }
    } catch (e) {
      reportError(e, 'Error setting attending');
      return null;
    }
  };
